import {HubApiRequest} from '../hub-api-request';
import {HubMethod} from '../constants/methods';
import {v4 as uuidv4} from 'uuid';
import {GetGameStartDataRequest, GetGameStartDataResponse} from '../protocol/get-game-start-data-request';

export class GetGameStartData extends HubApiRequest<GetGameStartDataRequest, GetGameStartDataResponse> {
    constructor(url: string, deviceIdentifier: string, data: GetGameStartDataRequest) {
        super(url, HubMethod.GET_GAME_START_DATA, deviceIdentifier, data, uuidv4());
    }
}
